import type { ConnectorTranslations } from "../../types/connectors";

export const connectors: ConnectorTranslations = {
  title: "Connect to Franklin",
  description: "Choose what this app can access with your Franklin account.",
  client: "App",
  clientIdentity: "Client ID",
  clientNotice: "The app provides its own name. Only connect an app you recognize and trust.",
  account: "Signed in as",
  organization: "Organization",
  chooseOrganization: "Choose an organization",
  permissions: "Permissions",
  permissionNotice:
    "Your current Franklin permissions always apply. You can revoke access in Connected apps at any time.",
  persistentAccess: "This connection stays available until you revoke it or your access expires.",
  noOrganizations:
    "You need an active organization membership to connect this app. You can deny this request and return to the app.",
  allow: "Allow access",
  deny: "Deny",
  pending: "Please wait…",
  loading: "Loading connection details…",
  unavailable: "Connectors are not available in this environment yet.",
  expired:
    "This connection request is invalid or has expired. Start a new connection from your app.",
  failed:
    "We could not complete this request. Try again. If your permissions changed, start a new connection from your app.",
  retry: "Try again",
  connectedTitle: "Connected apps",
  connectedDescription: "Manage apps that can access Franklin through your account.",
  empty: "No connected apps yet. Add Franklin from your app to get started.",
  unnamed: "Unnamed app",
  created: "Connected",
  lastUsed: "Last used",
  neverUsed: "Not used yet",
  revoked: "Access revoked",
  revoke: "Revoke access",
  revokeTitle: "Revoke this app’s access?",
  revokeDescription:
    "This connection will stop working immediately. To use it again, connect and approve the app again.",
  cancel: "Cancel",
  revokedSuccess: "Access revoked.",
  more: "Load more",
  settings: "Manage connected apps",
  uploadTitle: "Upload to Franklin",
  uploadDescription: "Choose the file requested by your connected app.",
  uploadFile: "Requested file",
  uploadBytes: "bytes",
  uploadDestination: "Destination",
  uploadNotice:
    "This adds a new document. Existing files and versions are kept. You can pause and resume by selecting this same file again.",
  uploadComplete: "Upload complete. Return to your connected app.",
  uploadClosed:
    "This upload was cancelled or has expired. Request a new upload from your connected app.",
  uploadChoose: "Choose file",
  uploadMismatch: "Choose a file with the requested name and exact byte size.",
  uploadProgress: "Upload progress",
  uploadFailed:
    "The upload could not finish. Check your connection, then resume. If access has changed, request a new upload.",
  uploadPause: "Pause upload",
  uploadStart: "Upload or resume",
  uploadCancel: "Cancel upload",
  actionTitle: "Review requested change",
  actionDescription: "A connected app is asking to make this change in Franklin.",
  actionPreview: "Proposed change",
  actionParameters: "All request details",
  actionNotice:
    "Approval applies once to this exact request and expires after 15 minutes. Franklin checks your permissions again before making the change.",
  approveAction: "Approve this change",
  actionStates: {
    approved: "Approved. Return to your connected app to complete this action.",
    denied: "Request declined. No change was made.",
    cancelled: "This request was cancelled.",
    succeeded: "This action has been completed.",
    conflicted:
      "The target or proposed change has changed. Ask your connected app for a new preview.",
    expired: "This request has expired. Ask your connected app for a new preview.",
  },
  scopes: {
    "franklin.read": "Read information you can access",
    "franklin.write": "Create and update information",
    "franklin.share": "Share information with others",
    "franklin.admin": "Manage organization settings and access",
    "franklin.sign": "Request signatures and manage signing workflows",
    "franklin.billing": "View billing information",
  },
};
